import { render, staticRenderFns } from "./RolePageLayout.vue?vue&type=template&id=5959e87c&scoped=true"
import script from "./RolePageLayout.vue?vue&type=script&lang=js"
export * from "./RolePageLayout.vue?vue&type=script&lang=js"
import style0 from "./RolePageLayout.vue?vue&type=style&index=0&id=5959e87c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5959e87c",
  null
  
)

export default component.exports